import styled, { useTheme } from 'styled-components';
import Modal, { FullHeightModalContent } from '../../../components/Modal';
import { BodyMedium, Heading4Text } from '../../../components/Texts';
import { PHONE_MEDIA_QUERY, useMediaQuery } from '../../../common/responsive';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import Button from '../../../components/Button';
import { selectThemeMode } from '../../../redux/slices/themeSlice';
import Steps from '../../../components/Steps';
import { useGetGiftsQuery } from '../../../redux/api/authorized/gifts';
import { selectPrivyToken } from '../../../redux/slices/auth';
import {
  useCompleteOnboardingMutation,
  useGetCurrentUserProfileQuery,
  useGetCurrentUserQuery,
} from '../../../redux/api/authorized/auth';
import { useNavigate } from 'react-router-dom';

const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  @media ${PHONE_MEDIA_QUERY} {
    margin-top: auto;
  }
`;

const Image = styled.img`
  width: 100%;
  max-width: 500px;
  height: auto;
  max-height: 60vh;
  object-fit: contain;
  object-position: center;
`;

const GiftClaimed = ({ onClose, fromDashboard = false }) => {
  const isMobile = useMediaQuery(PHONE_MEDIA_QUERY);
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const selectedTheme = useSelector(selectThemeMode);
  const [currentStep, setCurrentStep] = useState(0);
  const [completeOnboarding] = useCompleteOnboardingMutation();
  const navigate = useNavigate();
  const { refetch: refetchCurrentUser } = useGetCurrentUserProfileQuery();
  const token = useSelector(selectPrivyToken);

  const { data: gifts, refetch: refetchGifts } = useGetGiftsQuery({
    skip: !token,
  });

  useEffect(() => {
    refetchGifts();
  }, [refetchGifts]);

  const tradeImage = `/onboarding/trade-${isMobile ? 'mobile' : 'desktop'}${isMobile ? `-${selectedTheme}` : ''}.webp`;
  const giftClaimedImage = `/onboarding/gift-claimed-${isMobile ? 'mobile' : 'desktop'}-${selectedTheme}.webp`;
  const giftImage = `/onboarding/gift-${isMobile ? 'mobile' : 'desktop'}-${selectedTheme}.webp`;

  const imageMapper = fromDashboard
    ? {
        0: tradeImage,
        1: giftImage,
      }
    : {
        0: giftClaimedImage,
        1: tradeImage,
        2: giftImage,
      };

  const giftClaimedTitle = 'Gift Claimed';
  const tradeTitle = 'Trade Effortlessly';
  const giftTitle = 'Gift Easily';

  const titleMapper = fromDashboard
    ? {
        0: tradeTitle,
        1: giftTitle,
      }
    : {
        0: giftClaimedTitle,
        1: tradeTitle,
        2: giftTitle,
      };

  const giftClaimedDescription =
    'Your tokens are safely stored in your Portfolio.';
  const tradeDescription = 'Discover new investment opportunities.';
  const giftDescription = 'Share crypto with friends quickly.';

  const descriptionMapper = fromDashboard
    ? {
        0: tradeDescription,
        1: giftDescription,
      }
    : {
        0: giftClaimedDescription,
        1: tradeDescription,
        2: giftDescription,
      };

  return (
    <Modal onClose={onClose}>
      <FullHeightModalContent>
        <div style={{ display: 'flex', gap: 6, flexDirection: 'column' }}>
          <Heading4Text
            style={{
              fontWeight: '600',
              textAlign: 'center',
              color: theme.text.title,
            }}
          >
            {titleMapper[currentStep]}
          </Heading4Text>
          <BodyMedium
            style={{
              color: theme.text.regular,
              textAlign: 'center',
            }}
          >
            {descriptionMapper[currentStep]}
          </BodyMedium>
        </div>
        <Image src={imageMapper[currentStep]} />
        <ButtonContainer>
          <Button
            fullWidth={isMobile}
            loading={loading}
            onClick={async () => {
              if (
                currentStep === (fromDashboard ? 1 : 2) ||
                (!fromDashboard && gifts?.receivedGifts?.length > 1)
              ) {
                setLoading(true);
                await completeOnboarding().unwrap();
                await refetchCurrentUser();
                setLoading(false);
                onClose();
                navigate('/app/home');
              } else {
                setCurrentStep(currentStep + 1);
              }
            }}
          >
            CONTINUE
          </Button>
        </ButtonContainer>
        {(fromDashboard || gifts?.receivedGifts?.length <= 1) && (
          <Steps steps={fromDashboard ? 2 : 3} currentStep={currentStep} />
        )}
      </FullHeightModalContent>
    </Modal>
  );
};

export default GiftClaimed;
